<div class="campanha-dashabord">
    <!-- ROI por Campanha -->
    <div class="row">
        <div class="col-12">
            <sgt-campanha-roi-chart
                #roiChart>
            </sgt-campanha-roi-chart>
        </div>
    </div>
</div>